export default __webpack_public_path__ + "static/media/c1.b29abe66.png";